import { network } from 'services/network';

import { ReportTemplateBase } from 'api/endPoints/CreateNewTemplateFromReport';
import { Report } from 'api/endPoints/getReport';

export const overwriteTemplateFromReport = (params: QueryParams): Promise<QueryResponse> => {
    const url = `api/bo/reporting/overwriteTemplateFromReport`;
    return network.post(url, params).then((response) => {
        return response.data;
    });
};

export interface QueryResponse {
    report: Report;
}

export interface QueryParams extends ReportTemplateBase {
    templateId: number;
}
